<template>
  <div class="content">
    <mu-content-block>
      <h1 style="margin-top: 8px">My meal plans</h1>
      <p style="margin-top: 8px;">Browse meal plans generated and saved by you</p>
      <div style="margin-bottom: 24px">
        <mu-raised-button to="/recipes/generator" label="Generate meal plan"></mu-raised-button>
      </div>

    </mu-content-block>

    <mu-row align="left" gutter>
      <mu-col
        v-for="(item, index) in data"
        :key="'meal-plan-' +index"
        width="100"
        desktop="50"
        tablet="50"
        :style="{
          'background': 'url(' +getImage(item)+ ') center center no-repeat no-repeat',
          'backgroundSize': 'cover'
          }" class="text-white mealPlan bottom">
        <router-link class="text-white" :to="{name: 'MealPlanDetail', params: {id: item.id}}">
          <div class="inFront">
            <div>
              {{ item.availableDays.length }} days
            </div>
            <div class="recipeTitle">
              {{ item.name }}
            </div>
          </div>
          <div class="absolutePos" :style="{'backgroundImage': generateGradient()}"></div>
        </router-link>
      </mu-col>
    </mu-row>

    <div style="text-align: center">
      <mu-raised-button @click.native="loadMore" class="full-width" label="Load more"></mu-raised-button>
    </div>

  </div>
</template>
<script>
import RecipeApi from '../../api/Recipes'
import MuRaisedButton from "muse-ui/src/raisedButton/raisedButton";
import MuContentBlock from "muse-ui/src/contentBlock/contentBlock";

export default {
  components: {
    MuContentBlock,
    MuRaisedButton
  },
  name: "recipe-meal-plans",
  data() {
    return {
      data: null,
      paginationInfo: null
    }
  },
  methods: {
    getRandomInt(max) {
      return Math.floor(Math.random() * Math.floor(max));
    },
    getImage(item) {
      let self = this;
      let first = item.availableDays[0];
      let day = item.days.filter(function (item) {
        return item.name === first;
      });
      let firstMeal = item.availableMeals[0].toLowerCase();
      let randomObjectInMealPlan = (day[0][firstMeal]);
      return randomObjectInMealPlan[0].photoSmallUri;
    }
    ,
    generateGradient() {
      let hexValues = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e"];

      function populate(a) {
        for (let i = 0; i < 6; i++) {
          let x = Math.round(Math.random() * 14);
          let y = hexValues[x];
          a += y;
        }
        return a;
      }

      let newColor1 = populate('#');
      let newColor2 = populate('#');
      let angle = 45;
      return "linear-gradient(" + angle + "deg, " + newColor1 + ", " + newColor2 + ")";
    },
    loadMore() {
      RecipeApi.getMealPlans(this.paginationInfo.actualPage + 1, 10)
        .then((response) => {
          if (response.data.data.length === 0) {
            return;
          }

          this.paginationInfo = response.data.paginationInfo;
          this.data.push.apply(this.data, response.data.data);
        })
    }
  },
  mounted() {
    RecipeApi.getMealPlans(1, 10)
      .then((response) => {
        this.paginationInfo = response.data.paginationInfo;
        this.data = response.data.data;
      })
  }
}
</script>

<style lang="less">
.mealPlan {
  padding: 65px 16px 16px;
  position: relative;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  border-radius: 8px;
}

.inFront {
  position: relative;
  z-index: 2;
}

.recipeTitle {
  font-size: 16px;
  font-weight: bold;
}

.absolutePos {
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  border-radius: 8px;
  z-index: 1;
  opacity: 0.6;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.text-white {
  color: white !important;
}
</style>



// WEBPACK FOOTER //
// MealPlans.vue?3c99d47e